import { render } from "./KpiTargetDefinition.vue?vue&type=template&id=572634f3"
import script from "./KpiTargetDefinition.vue?vue&type=script&lang=js"
export * from "./KpiTargetDefinition.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__